import { render } from "./App.vue?vue&type=template&id=f6c2e26c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gioelecostagliola/Documents/Sviluppo/FRONTEND/diamonds-presentation-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__